var _path, _path2, _circle;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBellSvgrepoCom1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.9988 12.9459V12.0065C24.9988 6.84814 20.9699 2.6665 16 2.6665C11.0301 2.6665 7.00116 6.84814 7.00116 12.0065V12.9459C7.00116 14.0734 6.67963 15.1756 6.07707 16.1137L4.60048 18.4125C3.25176 20.5122 4.2814 23.3664 6.62715 24.0304C12.7637 25.7674 19.2364 25.7674 25.3728 24.0304C27.7187 23.3664 28.7483 20.5122 27.3995 18.4125L25.9229 16.1137C25.3204 15.1756 24.9988 14.0734 24.9988 12.9459Z",
    stroke: "#1C274C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 25.3335C10.8734 27.6639 13.2299 29.3335 16 29.3335C18.77 29.3335 21.1267 27.6639 22 25.3335",
    stroke: "#1C274C",
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 23.4375,
    cy: 6.1875,
    r: 4.8125,
    fill: "#EE2738"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBellSvgrepoCom1);
export default __webpack_public_path__ + "static/media/bell-svgrepo-com 1.c2fa1943bd7b27a2ca39a2fb0f00a7be.svg";
export { ForwardRef as ReactComponent };